import {
    ITimeRangeCreateRequest,
    TimeRangeCreateRequest,
} from '@kcftech/prometheus-client';
import { useMutation } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

export type UseCreateTimeRangeOptions = Readonly<{
    queryName: string;
}>;

export function createTimeRange(request: ITimeRangeCreateRequest) {
    return sdClient.createRange({ body: new TimeRangeCreateRequest(request) });
}

export function useCreateTimeRange({ queryName }: UseCreateTimeRangeOptions) {
    return useMutation({
        mutationFn: createTimeRange,

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [queryName],
            });
        },
    });
}
